import React, { useState, useEffect } from 'react';

import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';

import dateFormat from 'dateformat';

import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import { SideTab } from '../Components/SideTab';
import ProfileNotesLogsEmails from '../Components/ProfileNotesLogsEmails';
import ProfileNotesLogsEmailsMultiple from '../Components/ProfileNotesLogsEmailsMultiple';
import { IntegrationManager } from '../Components/IntegrationManager';
import { INTEGRATION_TYPE, INTEGRATION_OPTIONS } from '../Constants/Integrations';

export default function EmailInboxButton(props) {
  const [show, setShow] = useState(false);

  const [showIntegrationSetup, setShowIntegrationSetUp] = useState(false);
  const [allowedIntegrationServices, setAllowedIntegrationServices] = useState([]);
  const handleSetUpIntegrationHide = () => {
    setShowIntegrationSetUp(false);
  };

  const onIntegrationSetupClick = (serviceType) => {
    setShow(false);
    setAllowedIntegrationServices([...INTEGRATION_OPTIONS[serviceType]]);
    setShowIntegrationSetUp(true);
  };

  return (
    <>
      {/* Integration Manager */}
      <IntegrationManager
        userAccessToken={props.userAccessToken}
        userId={props.userId}
        showIntegrationSetup={showIntegrationSetup}
        onHide={handleSetUpIntegrationHide}
        allowedServices={allowedIntegrationServices}
      />

      <OverlayTrigger placement="top" overlay={<Tooltip placement="top">Emails</Tooltip>}>
        <i
          onClick={(e) => {
            setShow(true);
          }}
          className={`fas fa-envelope integratedEmailBtn ${show ? 'text-primary' : ''}`}
          title="email"
        ></i>
      </OverlayTrigger>

      <SideTab
        size="lg"
        position="right"
        title="Emails"
        onClose={(e) => setShow(false)}
        show={show}
      >
        {!props.ind && (
          <p class="alert alert-info small mt-3">
            Loading... <i class="fas fa-spinner fa-spin"></i>
          </p>
        )}

        {props.ind && (
          <ProfileNotesLogsEmailsMultiple
            {...props}
            onIntegrationSetupClick={(type) => onIntegrationSetupClick(type)}
          />
        )}
      </SideTab>
    </>
  );
}
